import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoTip from './InfoTip';

export default function SectionHeader({ icon: Icon, title, actions, info }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
        mb: 2,
        pb: 1.5,
        // Hairline: headings already carry the hierarchy, a heavy rule just adds noise
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Icon sx={{ color: 'primary.main', fontSize: 24 }} />
        {/* h4 (20px), not h5: h5 is the same 16px as body text, so titles blended in */}
        <Typography variant="h4" component="h2" fontWeight={700} color="text.primary">
          {title}
        </Typography>
        <InfoTip title={info} size={18} />
      </Box>
      {actions && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {actions}
        </Box>
      )}
    </Box>
  );
}
